import { FunctionComponent, useCallback } from "react";

import { ExchangeInlineReceiptPanel } from "./snowflakes/ExchangeInlineReceiptPanel/ExchangeInlineReceiptPanel.web";

import { ComponentProps } from "./props";

export const ExchangeInlineReceipt: FunctionComponent<ComponentProps> = ({
  receipt,
  runner,
  order,
  shouldDisplayBetWithMatchMe,
  isMatchMeAvailable,
  dispatchPanelEdit,
  dispatchPanelDone,
  dispatchPanelCancel,
  dispatchPanelPlace,
  dispatchToggleMatchMe,
  exchangeContext,
  betValues,
}) => {
  const handleExchangeReceiptPanelCancel = useCallback(() => {
    const betId = receipt?.unmatched?.betId ?? order?.betId;

    if (betId && runner) {
      dispatchPanelCancel(betId, runner);
    }
  }, [order, receipt?.unmatched?.betId, runner, dispatchPanelCancel]);

  const onEditCallback = useCallback(() => {
    if (order && runner) {
      dispatchPanelEdit(order.betId, runner);
    }
  }, [order, runner, dispatchPanelEdit]);

  const onBetWithMatchMeCallback = useCallback(() => {
    if (isMatchMeAvailable) {
      dispatchToggleMatchMe();
    }

    if (exchangeContext) {
      dispatchPanelPlace(exchangeContext, betValues);
    }
  }, [dispatchPanelPlace, dispatchToggleMatchMe, exchangeContext, betValues, isMatchMeAvailable]);

  const canCancel = !!order && receipt?.unmatched;
  const canEdit = canCancel && !receipt?.unmatched?.hasFreeBets;

  if (!receipt) {
    return null;
  }

  return (
    <ExchangeInlineReceiptPanel
      {...receipt}
      onDone={dispatchPanelDone}
      onCancel={canCancel ? handleExchangeReceiptPanelCancel : null}
      onEdit={canEdit ? onEditCallback : null}
      onBetWithMatchMe={canEdit ? onBetWithMatchMeCallback : null}
      shouldDisplayBetWithMatchMe={shouldDisplayBetWithMatchMe}
    />
  );
};
